import {fabric} from 'fabric'

export function makeCurve(canvas) {

    canvas.on({
        'object:selected': onObjectSelected,
        'object:moving': onObjectMoving,
        'before:selection:cleared': onBeforeSelectionCleared
    });

    var startPoint = null;
    var endPoint = null;
    var newUniqueId = null;

    function generateUniqueId() {
      const timestamp = new Date().getTime().toString(36);
      const randomPart = Math.random().toString(36).substr(2, 5);
      const uniqueId = `${timestamp}-${randomPart}`;
      return uniqueId;
    }
    
    canvas.on('mouse:down', function (o) {
      var pointer = canvas.getPointer(o.e);
      console.log('startPoint', startPoint);


      if (startPoint === null) {
        startPoint = new fabric.Circle({
          left: pointer.x,
          top: pointer.y,
          strokeWidth: 2,
          radius: 4,
          fill: '#fff',
          stroke: '#666',
          originX: 'center',
          originY: 'center',
          hasControls: false,
        });
        canvas.add(startPoint);

      } else if (endPoint === null) {

        newUniqueId = generateUniqueId()
        var line = new fabric.Path(`M ${pointer.x} ${pointer.y} Q 100, 100, 200, 0`, { fill: '', stroke: "#000", objectCaching: false, selectable: true, evented: false, id: newUniqueId, name: 'line' });

        line.path[0][1] = startPoint.left;
        line.path[0][2] = startPoint.top;
        line.path[1][1] = ((startPoint.left + pointer.x) / 2);
        line.path[1][2] = ((startPoint.top + pointer.y) / 2) + 100;
        line.path[1][3] = pointer.x;
        line.path[1][4] = pointer.y;

        updatePathBoundingBox(line);
        canvas.add(line);

        var p1 = makeCurvePoint(((startPoint.left + pointer.x) / 2), ((startPoint.top + pointer.y) / 2) + 100, null, line, null)
        p1.name = "p1";
        canvas.add(p1);

        var p0 = makeCurveCircle(startPoint.left, startPoint.top, line, p1, null);
        p0.name = "p0";
        canvas.add(p0);

        var p2 = makeCurveCircle(pointer.x, pointer.y, null, p1, line);
        p2.name = "p2";
        canvas.add(p2);

        canvas.remove(startPoint);
        startPoint = null;
        endPoint = null;
      }


    });

    (function drawQuadratic() {
      var line = new fabric.Path('M 0 0 Q 100, 100, 200, 0', { fill: '', stroke: 'black', objectCaching: false, selectable: true });
  
      line.path[0][1] = 100;
      line.path[0][2] = 100;
  
      line.path[1][1] = 200;
      line.path[1][2] = 200;
  
      line.path[1][3] = 300;
      line.path[1][4] = 100;
      
     updateDims(line);
     updatePathBoundingBox(line);
  
     // line.selectable = false;
      canvas.add(line);
      var p1 = makeCurvePoint(200, 200, null, line, null)
      p1.name = "p1";
      canvas.add(p1);
  
      var p0 = makeCurveCircle(100, 100, line, p1, null);
      p0.name = "p0";
      canvas.add(p0);
  
      var p2 = makeCurveCircle(300, 100, null, p1, line);
      p2.name = "p2";
      canvas.add(p2);
  
    })();
    
    function updatePathBoundingBox(item) {
        var dims = item._calcDimensions()
        item.set({
          width: dims.width,
          height: dims.height,
          left: dims.left,
          top: dims.top,
          pathOffset: {
            x: dims.width / 2 + dims.left,
            y: dims.height / 2 + dims.top
          },
           dirty: false,
           id: newUniqueId,
        })
        item.setCoords()
      }
    
      function updateDims(path) {
        var dims = path._calcDimensions(),
            prevDims = path.prevDims || {},
            leftDiff = dims.left - (prevDims.left || 0),
            topDiff = dims.top - (prevDims.top || 0);
  
        path.setWidth(dims.width);
        path.setHeight(dims.height);
  
        if (dims.left < 0) {
            path.pathOffset.x = path.width/2 + dims.left;
            path.left = path.left + leftDiff;
        } else {
            path.pathOffset.x = path.width/2;
        }
        if (dims.top < 0) {
            path.pathOffset.y = path.height/2 + dims.top;
            path.top = path.top + topDiff;
        } else {
             path.pathOffset.y = path.height/2;   
        }
        path.prevDims = dims;
        path.setCoords();
    }
  
    function makeCurveCircle(left, top, line1, line2, line3) {
      var c = new fabric.Circle({
        left: left,
        top: top,
        strokeWidth: 2,
        radius: 4,
        fill: '#fff',
        stroke: '#666',
        originX: 'center',      
        originY: 'center',
        id: newUniqueId,
      });
  
      c.hasBorders = c.hasControls = false;
  
      c.line1 = line1;
      c.line2 = line2;
      c.line3 = line3;
  
      return c;
    }
  
    function makeCurvePoint(left, top, line1, line2, line3) {
      var c = new fabric.Circle({
        left: left,
        top: top,
        strokeWidth: 3,
        radius: 6,
        fill: '#fff',
        stroke: '#666',
        originX: 'center',      
        originY: 'center',
        selectable: true,
        id: newUniqueId,
      });
  
      c.hasBorders = c.hasControls = false;
  
      c.line1 = line1;
      c.line2 = line2;
      c.line3 = line3;
  
      return c;
    }
  
    function onObjectSelected(e) {
      var activeObject = e.target;
     
      if(e.target.type === 'path'){
        console.log(canvas.getObjects());
        let n=0;
        canvas.getObjects().forEach((obj) => {
            if(obj.type === 'circle'){
                n++;
            }
        })
        if(n===0){
            let line = canvas.getActiveObject();
            var p1 = makeCurvePoint(line.path[1][1], line.path[1][2], null, line, null)
            p1.name = "p1";
            canvas.add(p1);
  
            var p0 = makeCurveCircle(line.path[0][1], line.path[0][2], line, p1, null);
            p0.name = "p0";
            canvas.add(p0);
  
            var p2 = makeCurveCircle(line.path[1][3], line.path[1][4], null, p1, line);
            p2.name = "p2";
            canvas.add(p2);
            canvas.renderAll();
            updatePathBoundingBox(line);
            return;
        }
        canvas.getObjects().forEach((obj) => {
            if(obj.type === 'circle'){
                canvas.remove(obj)
            }
            canvas.renderAll();
          });
      }
      if (activeObject.name === "p0" || activeObject.name === "p2") {
        activeObject.line2.animate('opacity', '1', {
          duration: 200,
          onChange: canvas.renderAll.bind(canvas),
        });
        activeObject.line2.selectable = true;
      }
    }
  
    function onBeforeSelectionCleared(e) {
      var activeObject = e.target;
      if (activeObject.name === "p0" || activeObject.name === "p2") {
        activeObject.line2.animate('opacity', '0', {
          duration: 200,
          onChange: canvas.renderAll.bind(canvas),
        });
        // activeObject.line2.selectable = false;
      }
      else if (activeObject.name === "p1") {
        activeObject.animate('opacity', '0', {
          duration: 200,
          onChange: canvas.renderAll.bind(canvas),
        });
        // activeObject.selectable = false;
      }
    }
  
    function onObjectMoving(e) {
      if (e.target.name === "p0" || e.target.name === "p2") {
        let p = e.target;
        if (p.line1) {
          p.line1.path[0][1] = p.left;
          p.line1.path[0][2] = p.top;
          updatePathBoundingBox(p.line1)
        }
        else if (p.line3) {
          p.line3.path[1][3] = p.left;
          p.line3.path[1][4] = p.top;
          updatePathBoundingBox(p.line3)
        }
      }
      else if (e.target.name === "p1") {
        let p = e.target;
  
        if (p.line2) {
          p.line2.path[1][1] = p.left;
          p.line2.path[1][2] = p.top;
          updatePathBoundingBox(p.line2)
        }
      }
      else if (e.target.name === "p0" || e.target.name === "p2") {
        let p = e.target;
  
        p.line1 && p.line1.set({ 'x2': p.left, 'y2': p.top });
        p.line2 && p.line2.set({ 'x1': p.left, 'y1': p.top });
        p.line3 && p.line3.set({ 'x1': p.left, 'y1': p.top });
        p.line4 && p.line4.set({ 'x1': p.left, 'y1': p.top });
      }
    }
  }